import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { ModelID, WorkOrder } from '@/types';
import { get } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { featureKeys, featurePath, WorkOrderSearchParams } from '.';

type QueryFnType = typeof findWorkOrder;

type UseWorkOrderOptions = {
  id: ModelID;
  search?: WorkOrderSearchParams;
  config?: QueryConfig<QueryFnType>;
};

const findWorkOrder = (id: ModelID, search: any = {}) =>
  get<WorkOrder>(`${featurePath}/${id}`, search);

export const useWorkOrder = ({ id, search = {}, config = {} }: UseWorkOrderOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: featureKeys.detail(+id),
    queryFn: () => findWorkOrder(id, search),
  });
};
